export default __webpack_public_path__ + "static/media/hexagon-inner-14.2b76848a.svg";